import { html, nothing, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { customElement } from '../base-element';
import { PopoverBaseWC } from '../popover/src/popover-base.wc';
import styles from './popover-tooltip.scss?inline';

@customElement('ps-popover-tooltip')
export class PopoverTooltipWC extends PopoverBaseWC {
  static styles = unsafeCSS(styles);

  /**
   * Popover size
   */
  @property({ reflect: true }) size: 'none' | 'xsmall' | 'small' | 'large' =
    'large';

  constructor() {
    super();
    this.distance = 12;
    this.skidding = 8;
    this.hasArrow = true;

    this.triggerAction = 'click-and-hover';
    this.closeOnClickOutside = false;
    this.disableFocusTrap = true;
  }

  render() {
    return html`
      <div
        id="popover-container"
        class=${classMap({
          'c-popover-tooltip': true,
          'c-popover-tooltip--shown': this.active,
        })}
        style="transform: ${this.transform}"
      >
        <slot class="c-popover-tooltip__body"></slot>

        <div class="c-popover-tooltip__arrow" id="popover-arrow"></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-popover-tooltip': PopoverTooltipWC;
  }
  enum PSElementTagNameMap {
    'ps-popover-tooltip' = 'ps-ppopover-tooltip',
  }
}
